module.exports = __webpack_public_path__ + "img/ray-team.78b7a094.svg";